import { useEffect } from "react";

interface UseErrorBoxReturnData {
  elementId: string;
  messages: string[];
}

export const useErrorBox = (text: string | string[] | undefined, animation: boolean): UseErrorBoxReturnData => {
  const elementId = `ErrorBox${new Date().getTime()}`;
  const messages = text === undefined ? [] : ([] as string[]).concat(text);

  useEffect(() => {
    if (animation) document.getElementById(elementId)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return {
    elementId,
    messages,
  };
};
